import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../../../../api/client';
import ScheduleIcon from '@mui/icons-material/Schedule';

const ExpirySection = ({ expiryData }) => {
  const { t, i18n } = useTranslation();

  const formatDate = (dateString) => {
    if (!dateString) return t('dashboard.notAvailable');
    const locale = i18n.language === 'hi' ? 'hi-IN' : i18n.language || 'en-US';
    const date = new Date(dateString);
    return date.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getDaysUntilExpiry = (expiryDate) => {
    if (!expiryDate) return 0;
    const now = new Date();
    const expiry = new Date(expiryDate);
    const diffTime = expiry - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  if (!expiryData) {
    return (
      <div className="flex justify-center items-center h-48 text-gray-500 ">
        {t('dashboard.loadingExpiry')}
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex flex-col mb-4">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <ScheduleIcon className="text-blue-600 text-lg" />
            <h3 className="text-base font-semibold text-gray-900">{t('dashboard.creditExpiryOverview')}</h3>
          </div>
        </div>
        <p className="text-sm text-gray-600">{t('dashboard.creditExpiryDescription')}</p>
      </div>

      {/* Latest Expiry Date Display */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-3 border border-blue-200 mb-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="  text-blue-800 mb-1">{t('dashboard.latestExpiryDate')}</div>
            <div className="text-2xl font-bold text-blue-900">
              {expiryData.nearest_expiry_date ? formatDate(expiryData.nearest_expiry_date) : t('dashboard.noExpiryDates')}
            </div>
            {expiryData.nearest_expiry_date && (
              <div className=" text-blue-700 mt-1">

                {getDaysUntilExpiry(expiryData.nearest_expiry_date) > 0
                  ? t('dashboard.daysRemaining', { count: getDaysUntilExpiry(expiryData.nearest_expiry_date) })
                  : t('dashboard.expired')


                }
              </div>
            )}
          </div>
          <div className="text-right">
            <div className=" text-blue-700 mb-1">{t('dashboard.totalExpiring')}</div>
            <div className="text-xl font-bold text-blue-900">
              {expiryData.total_active_expiring ?? expiryData.total_expiring_credits}
            </div>
            <div className=" text-blue-600">{t('dashboard.credits')}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpirySection;
